import './WrapperLayout.scss';
import React from 'react';
import { Row } from 'antd';

interface IProps {
  style?: string;  
  align?: 'top' | 'middle' | 'bottom';
  justify?: 'space-between'| 'space-around' | 'start' | 'end' | 'center';
  padding?: 'none' | 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

const WrapperLayout: React.SFC<IProps> = ({
  style = '',
  align,
  justify = 'start',
  padding = 'sm',
  children,
}) => (
  <Row className={ `wrapper-layout ${ style }` } type='flex' justify='center' align='middle'>
    <Row className={ `content p-${ padding }` } type='flex' align={ align } justify={ justify }>
      { children }
    </Row>
  </Row>
); 

export default WrapperLayout;


// WEBPACK FOOTER //
// ./src/components/Shared/WrapperLayout/WrapperLayout.tsx